$(document).ready(function(){
    $('.mobile-toggle').click(function(){
        $('nav .links').toggleClass('active');
    });
});

$(document).on('click', '.dropdown-toggler', function(e){
    e.preventDefault();
    var item = $(this).closest('li');
    if (item.hasClass('m-active')){
        // console.log('HAS');
        item.removeClass('m-active');
        item.removeClass('active');
    } else {
        // console.log('hAS NOT');
        item.addClass('m-active');
        item.addClass('active');
    }
});

$(document).on('mouseenter', 'nav li', function(){
    // console.log('HERE');
    $(this).addClass('active');
});

$(document).on('mouseleave', 'nav li', function(){
    // console.log('HERE 2');
    $(this).removeClass('active');
    $(this).removeClass('m-active');
}); 